'use strict';

export function stripeElementsConfig(StripeElementsProvider) {
  'ngInject';
  StripeElementsProvider.setAPIKey("pk_test_6GaaGPeZZmHOvCeot2KXHhws");
}

export function routeConfig($urlRouterProvider, $locationProvider) {
  'ngInject';

  $urlRouterProvider.otherwise('/');

  $locationProvider.html5Mode(true);
}

export function themeConfig(PLATFORM_CONFIG, APP_CONFIG, CUSTOM_STYLES) {
  'ngInject';

  var theme = PLATFORM_CONFIG.data.theme || 'cerulean';
  var backgroundUrl = PLATFORM_CONFIG.data.background || '/assets/images/background.jpg';

  jQuery('head title').text(APP_CONFIG.data.moduleConfig["general"].clientName);

  jQuery("body").css('background-image', 'url(' + backgroundUrl + ')');

  jQuery('head').append('<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootswatch/3.3.7/'+theme+'/bootstrap.min.css" type="text/css" />');

  jQuery('head').append("<style type='text/css'>"+CUSTOM_STYLES.data.css+"</style>");
}


export function decorateTextAngular($provide){
  'ngInject';
  
  $provide.decorator('taOptions', ['taRegisterTool', '$delegate', function(taRegisterTool, taOptions){

    taRegisterTool('backgroundColor', {
      display: "<span class='bar-btn-dropdown dropdown' style='padding:0px;'>" +
      "<button title='Background Color' class='btn dropdown-toggle' type='button' ng-disabled='showHtml()' style='background-color: transparent; border: transparent; padding-top: 8px 12px'><span style='color:black; background-color:yellow'>ABC</span><i class='fa fa-caret-down'></i></button>" +
      "<ul class='dropdown-menu'><li ng-repeat='o in options'><a class='checked-dropdown' style='width: 100%' type='button' ng-click='action($event, o.css)'><div style='border:1px solid black; float:left; width:20px; background-color: {{o.css}}; '>&nbsp;</div>&nbsp;&nbsp;<i ng-if='o.active' class='fa fa-check'></i>{{o.name}}</a></li></ul></span>",
      action: function (event, color) {
        //Ask if event is really an event.
        if (!!event.stopPropagation) {
          //With this, you stop the event of textAngular.
          event.stopPropagation();
          //Then click in the body to close the dropdown.
          $("body").trigger("click");
        }
        return this.$editor().wrapSelection('backColor', color);
      },
      options: [
        { name: 'Aqua', css: "aqua" },
        { name: 'Black', css: "black" },
        { name: 'Blue', css: "blue" },
        { name: 'Fuchsia', css: "fuchsia" },
        { name: 'Gray', css: "gray" },
        { name: 'Green', css: "green" },
        { name: 'Lime', css: "lime" },
        { name: 'Maroon', css: "maroon" },
        { name: 'Navy', css: "navy" },
        { name: 'Olive', css: "olive" },
        { name: 'Purple', css: "purple" },
        { name: 'Red', css: "red" },
        { name: 'Silver', css: "silver" },
        { name: 'Teal', css: "teal" },
        { name: 'White', css: "white" },
        { name: 'Yellow', css: "yellow" }
      ]
    });

    taRegisterTool('fontColor', {
      display: "<span class='bar-btn-dropdown dropdown' style='padding:0px;'>" +
      "<button title='Text Color' class='btn dropdown-toggle' type='button' ng-disabled='showHtml()' style='background-color: transparent; border: transparent; padding-top: 8px 12px'><span style='color:red'>A</span><span style='color:green'>B</span><span style='color:blue'>C</span><i class='fa fa-caret-down'></i></button>" +
      "<ul class='dropdown-menu'><li ng-repeat='o in options'><a class='checked-dropdown' style='width: 100%' type='button' ng-click='action($event, o.css)'><div style='border:1px solid black; float:left; width:20px; background-color: {{o.css}}; '>&nbsp;</div>&nbsp;&nbsp;<i ng-if='o.active' class='fa fa-check'></i>{{o.name}}</a></li></ul></span>",
      action: function (event, color) {
        //Ask if event is really an event.
        if (!!event.stopPropagation) {
          //With this, you stop the event of textAngular.
          event.stopPropagation();
          //Then click in the body to close the dropdown.
          $("body").trigger("click");
        }
        return this.$editor().wrapSelection('foreColor', color);
      },
      options: [
        { name: 'Aqua', css: "aqua" },
        { name: 'Black', css: "black" },
        { name: 'Blue', css: "blue" },
        { name: 'Fuchsia', css: "fuchsia" },
        { name: 'Gray', css: "gray" },
        { name: 'Green', css: "green" },
        { name: 'Lime', css: "lime" },
        { name: 'Maroon', css: "maroon" },
        { name: 'Navy', css: "navy" },
        { name: 'Olive', css: "olive" },
        { name: 'Purple', css: "purple" },
        { name: 'Red', css: "red" },
        { name: 'Silver', css: "silver" },
        { name: 'Teal', css: "teal" },
        { name: 'White', css: "white" },
        { name: 'Yellow', css: "yellow" }
      ]
    });

    taRegisterTool('fontName', {
      display: "<span class='bar-btn-dropdown dropdown' style='padding:0px;'>" +
      "<button title='Font Face' class='btn dropdown-toggle' type='button' ng-disabled='showHtml()' style='background-color: transparent; border: transparent; padding-top: 8px 12px'><i class='fa fa-font'></i><i class='fa fa-caret-down'></i></button>" +
      "<ul class='dropdown-menu'><li ng-repeat='o in options'><a class='checked-dropdown' style='font-family: {{o.css}}; width: 100%' type='button' ng-click='action($event, o.css)'><i ng-if='o.active' class='fa fa-check'></i>{{o.name}}</a></li></ul></span>",
      action: function (event, font) {
        //Ask if event is really an event.
        if (!!event.stopPropagation) {
          //With this, you stop the event of textAngular.
          event.stopPropagation();
          //Then click in the body to close the dropdown.
          $("body").trigger("click");
        }
        return this.$editor().wrapSelection('fontName', font);
      },
      options: [
        { name: 'Sans-Serif', css: 'Arial, Helvetica, sans-serif' },
        { name: 'Serif', css: "'times new roman', serif" },
        { name: 'Wide', css: "'arial black', sans-serif" },
        { name: 'Narrow', css: "'arial narrow', sans-serif" },
        { name: 'Comic Sans MS', css: "'comic sans ms', sans-serif" },
        { name: 'Courier New', css: "'courier new', monospace" },
        { name: 'Garamond', css: 'garamond, serif' },
        { name: 'Georgia', css: 'georgia, serif' },
        { name: 'Tahoma', css: 'tahoma, sans-serif' },
        { name: 'Trebuchet MS', css: "'trebuchet ms', sans-serif" },
        { name: "Helvetica", css: "'Helvetica Neue', Helvetica, Arial, sans-serif" },
        { name: 'Verdana', css: 'verdana, sans-serif' },
        { name: 'Proxima Nova', css: 'proxima_nova_rgregular' }
      ]
    });

    taRegisterTool('fontSize', {
      display: "<span class='bar-btn-dropdown dropdown' style='padding:0px'>" +
      "<button title='Font Size' class='btn dropdown-toggle' type='button' ng-disabled='showHtml()' style='background-color: transparent; border: transparent; padding-top: 8px 12px'><i class='fa fa-text-height'></i><i class='fa fa-caret-down'></i></button>" +
      "<ul class='dropdown-menu'><li ng-repeat='o in options'><a class='checked-dropdown' style='font-size: {{o.css}}; width: 100%' type='button' ng-click='action($event, o.value)'><i ng-if='o.active' class='fa fa-check'></i> {{o.name}}</a></li></ul>" +
      "</span>",
      action: function (event, size) {
        //Ask if event is really an event.
        if (!!event.stopPropagation) {
          //With this, you stop the event of textAngular.
          event.stopPropagation();
          //Then click in the body to close the dropdown.
          $("body").trigger("click");
        }
        return this.$editor().wrapSelection('fontSize', parseInt(size));
      },
      options: [
        { name: 'XX Small', css: 'xx-small', value: 1 },
        { name: 'X Small', css: 'x-small', value: 2 },
        { name: 'Small', css: 'small', value: 3 },
        { name: 'Medium', css: 'medium', value: 4 },
        { name: 'Large', css: 'large', value: 5 },
        { name: 'X Large', css: 'x-large', value: 6 },
        { name: 'XX Large', css: 'xx-large', value: 7 }

      ]
    });

    // add the button to the default toolbar definition
    //taOptions.toolbar[1].push('backgroundColor','fontColor','fontName','fontSize');
    return taOptions;
  }]);
}


// WEBPACK FOOTER //
// ./client/app/app.config.js